import { ISelectOption } from 'app/interfaces/ISelectOption';
import { GlobalVariables } from 'app/services/globals';

import { adxAuthTypes, azureBlobFSAuthTypes, azureStorageAuthTypes, SQLAuthenticationType } from 'shell-models-lib';

export { azureDefaultAuthRefTypes } from 'shell-models-lib';

// for the below mergeUamiCredential functions, creating copy of the i/p array to append and return to prevent duplicate.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function mergeUamiCredentialOption(options: Array<ISelectOption<any>>): Array<ISelectOption<any>> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let copy: Array<ISelectOption<any>>;
    if (options) {
        copy = [...options];
        copy.push({
            label: stringResources.AuthenticationType_UserAssignedManagedIdentity,
            value: azureBlobFSAuthTypes.UserAssignedManagedIdentity
        });
    }
    return copy;
}

// the following function is used by AzureDataExplorer. This needs a different function to keep the value of UAMI auth type inline with other auth types in this LS.
export function mergeUamiCredentialOptionAdx(options: Array<ISelectOption<string>>): Array<ISelectOption<string>> {
    let copy: Array<ISelectOption<string>>;
    if (options) {
        copy = [...options];
        copy.push({
            label: stringResources.AuthenticationType_UserAssignedManagedIdentity,
            value: adxAuthTypes.UserAssignedManagedIdentityAuthentication
        });
    }
    return copy;
}

// the following function is shared by SQL and SQL-MI. Creating copy of the i/p array to append and return to prevent duplicate
export function mergeUamiCredentialOptionSql(options: Array<ISelectOption<SQLAuthenticationType>>): Array<ISelectOption<SQLAuthenticationType>> {
    let copy: Array<ISelectOption<SQLAuthenticationType>>;
    if (options) {
        copy = [...options];
        copy.push({
            label: stringResources.AuthenticationType_UserAssignedManagedIdentity,
            value: SQLAuthenticationType.UserAssignedManagedIdentity
        });
    }
    return copy;
}

export function mergeUserAuthCredentialOption(options: Array<ISelectOption<string>>, value: string): Array<ISelectOption<string>> {
    let copy: Array<ISelectOption<string>> = [];
    if (options) {
        copy = [...options];
    }
    if (GlobalVariables.enableConnectorUserAuthCred) {
        copy.push({
            label: stringResources.ModelName_UserAuthentication,
            value
        });
    }
    return copy;
}

export const defaultSqlAuthenticationOptionAKV: Array<ISelectOption<SQLAuthenticationType>> = [
    {
        label: stringResources.AuthenticationType_SqlOrManagedServiceIdentity,
        value: SQLAuthenticationType.SqlOrManagedServiceIdentity
    },
    {
        label: stringResources.AuthenticationType_ServicePrincipal,
        value: SQLAuthenticationType.ServicePrincipal
    }
];

export const defaultSqlAuthenticationOptionNoAKV: Array<ISelectOption<SQLAuthenticationType>> = [
    {
        label: stringResources.AuthenticationType_Select_SQL_Option,
        value: SQLAuthenticationType.SQL
    },
    {
        label: stringResources.AuthenticationType_ManagedServiceIdentity,
        value: SQLAuthenticationType.ManagedServiceIdentity
    },
    {
        label: stringResources.AuthenticationType_ServicePrincipal,
        value: SQLAuthenticationType.ServicePrincipal
    }
];

export const combinedMIAuthenticationOption: Array<ISelectOption<string>> = [
    {
        label: stringResources.AuthenticationType_ManagedServiceIdentity,
        value: azureStorageAuthTypes.MSIAuthentication
    },
    {
        label: stringResources.AuthenticationType_UserAssignedManagedIdentity,
        value: azureStorageAuthTypes.UserAssignedManagedIdentity
    }
];

export const msiCredentialName: string = 'DataFactorySystemIdentity';
